<template>
    <section class="flex flex-col gap-6 pb-6 pt-6 sm:flex-row sm:items-end sm:gap-8 md:pt-10">
        <div v-if="image || $slots.art" class="shrink-0">
            <slot name="art">
                <ArtworkImage :src="image" :title="title" :subtitle="imageSubtitle"
                    class="h-44 w-44 shadow-lift sm:h-48 sm:w-48 lg:h-56 lg:w-56"
                    :class="round ? 'rounded-full' : 'rounded-lg'" />
            </slot>
        </div>
        <div class="min-w-0 flex-1">
            <p v-if="type" class="text-sm text-nomad-300">{{ type }}</p>
            <h1 class="mt-1 line-clamp-2 break-words text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl 2xl:text-5xl">
                {{ title }}
            </h1>
            <div v-if="$slots.meta" class="mt-3 text-sm text-nomad-300">
                <slot name="meta"></slot>
            </div>
        </div>
    </section>
    <div v-if="$slots.actions" class="flex flex-wrap items-center gap-1 pb-6 sm:gap-3">
        <slot name="actions"></slot>
    </div>
</template>
<script>
import ArtworkImage from "@/components/ui/ArtworkImage.vue";

export default {
    name: "PageHeader",
    components: { ArtworkImage },
    props: {
        type: String,
        title: String,
        image: String,
        imageSubtitle: String,
        round: Boolean,
    },
};
</script>
